import { render, staticRenderFns } from "./PopupOffingWavePointDetail.vue?vue&type=template&id=33d0cf38"
import script from "./PopupOffingWavePointDetail.vue?vue&type=script&lang=js"
export * from "./PopupOffingWavePointDetail.vue?vue&type=script&lang=js"
import style0 from "./PopupOffingWavePointDetail.vue?vue&type=style&index=0&id=33d0cf38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports